/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateProjectPersonInput = {
    id: string;
    roleId?: string | null | undefined;
    isContactPerson?: boolean | null | undefined;
    hasDismissedSetToRunningNotification?: boolean | null | undefined;
    isProjectGroupUpdate?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateProjectPersonMutationVariables = {
    input: UpdateProjectPersonInput;
};
export type updateProjectPersonMutationResponse = {
    readonly updateProjectPerson: {
        readonly projectPerson: {
            readonly isContactPerson: boolean | null;
            readonly role: {
                readonly id: string;
                readonly name: string | null;
            } | null;
        } | null;
    } | null;
};
export type updateProjectPersonMutation = {
    readonly response: updateProjectPersonMutationResponse;
    readonly variables: updateProjectPersonMutationVariables;
};



/*
mutation updateProjectPersonMutation(
  $input: UpdateProjectPersonInput!
) {
  updateProjectPerson(input: $input) {
    projectPerson {
      isContactPerson
      role {
        id
        name
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectPersonInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isContactPerson",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPersonPayload",
        "kind": "LinkedField",
        "name": "updateProjectPerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectPerson",
            "kind": "LinkedField",
            "name": "projectPerson",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPersonPayload",
        "kind": "LinkedField",
        "name": "updateProjectPerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectPerson",
            "kind": "LinkedField",
            "name": "projectPerson",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateProjectPersonMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectPersonMutation(\n  $input: UpdateProjectPersonInput!\n) {\n  updateProjectPerson(input: $input) {\n    projectPerson {\n      isContactPerson\n      role {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '45a3bb3189bb8ca09de9b4ba6316a5c3';
export default node;
